export default __webpack_public_path__ + "static/media/about-main.2684c0fd.png";